import React,{useEffect} from 'react'
import List from "@mui/material/List";
import {
    CircularProgress,
    DialogActions,
    DialogContent,
    DialogContentText,
    ListItemButton, Table, TableBody, TableCell, tableCellClasses, TableHead, TableRow
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import axios from "axios";
import {Link} from "react-router-dom";
import {styled} from "@mui/material/styles";
const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.common.black,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({

    '&:last-child td, &:last-child th': {
        border: 1,
    },
}));
const SelectCustomer = ({setChange})=>{
    const [loading , setLoading] = React.useState(true);
    const [dialogSelectCustomer , setDialogSelectCustomer] = React.useState(true);
    const [customerList , setCustomerList] = React.useState("");
    const [key , setKey] = React.useState("");
    useEffect(()=>{
        const data = {
            search : "sdd",
        }
        axios.post("https://app.zhivay.com/api/get_customerlist.php",data)
            .then(response =>{
                console.log(response.data);
                setCustomerList(response.data);
                setLoading(false);
            });
        const data1 = {
            keyid:key,
        };
        axios.post('https://app.zhivay.com/api/get_createfactor.php', data1)
            .then(respone => {
                if (respone.data.status === "ok"){
                    setKey(respone.data.key);
                }
            })
            .catch(error => console.log(error));

    },"")
    const handleCustomerClick = (id,name,address,tel)=>{
        localStorage.setItem('cstname',name);
        localStorage.setItem('csttel',tel);
        localStorage.setItem('cstaddress',address);
        localStorage.setItem('cstid',id);
        localStorage.setItem('ftype',"factor");
    }
    const handleDialogClose = ()=>{
        setDialogSelectCustomer(false);
        setChange(true);
        localStorage.removeItem('cstname');
        localStorage.removeItem('csttel');
        localStorage.removeItem('cstaddress');
        localStorage.removeItem('cstid');
        localStorage.removeItem('ftype');
    }
    return(
        <div>
            <Dialog
                open={dialogSelectCustomer}
                onClose={handleDialogClose}
                scroll="paper"
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                {/*<DialogTitle id="scroll-dialog-title">Subscribe</DialogTitle>*/}
                <DialogContent>
                    <DialogContentText
                        id="scroll-dialog-description"
                        tabIndex={-1}>

                            <Table
                                stickyHeader
                                sx={{ minWidth: 250,maxHeight:'80%',overflowY:'auto',}}
                                className='tbl-pishfactor'>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell align="center">توسط</StyledTableCell>
                                        <StyledTableCell align="center">شماره تماس</StyledTableCell>
                                        <StyledTableCell align="center">نام مشتری</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                {!loading ?
                                <TableBody>
                                    {customerList.map(list => (
                                        <StyledTableRow hover
                                            component={Link} to={`factors/${key}`}
                                            onClick={() => handleCustomerClick(list.customer_id,list.customer_name,list.customer_address,list.customer_tel)}
                                            key={list.pt_id}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <StyledTableCell component="th" scope="row" align="center">
                                                {list.customer_by}
                                            </StyledTableCell>
                                            <StyledTableCell component="th" scope="row" align="center">
                                                {list.customer_tel}
                                            </StyledTableCell>
                                            <StyledTableCell component="th" scope="row" align="center">
                                                {list.customer_name}
                                            </StyledTableCell>
                                        </StyledTableRow >
                                    ))}
                                </TableBody>
                                : <CircularProgress sx={{margin:2}} /> }
                            </Table>

                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick>Cancel</Button>
                    <Button onClick>Subscribe</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}
export default SelectCustomer